'use client';

import { c as _c } from "react/compiler-runtime";
import { type DehydratedState, HydrationBoundary, type QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { createTRPCClient, httpBatchLink } from '@trpc/client';
import { useState } from 'react';
import superjson from 'superjson';
import { TRPCProvider } from '@/app/api/trpc/config';
import { makeQueryClient } from '@/app/api/trpc/query-client';
import type { AppRouter } from '@/backend/serverApi';
import { env } from '@/env';
const apiUrl = env.NEXT_PUBLIC_API_URL;
let browserQueryClient: QueryClient | undefined;
function getQueryClient() {
  if (typeof window === 'undefined') {
    return makeQueryClient();
  }
  browserQueryClient ??= makeQueryClient();
  return browserQueryClient;
}
export default function TrpcProvider(t0) {
  const $ = _c(7);
  const {
    children,
    dehydratedState
  } = t0;
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = getQueryClient();
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  const queryClient = t1;
  const [trpcClient] = useState(_temp2);
  let t2;
  if ($[1] !== children || $[2] !== trpcClient) {
    t2 = <TRPCProvider trpcClient={trpcClient} queryClient={queryClient}>{children}</TRPCProvider>;
    $[1] = children;
    $[2] = trpcClient;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  let t3;
  if ($[4] !== dehydratedState || $[5] !== t2) {
    t3 = <QueryClientProvider client={queryClient}><HydrationBoundary state={dehydratedState} queryClient={queryClient}>{t2}</HydrationBoundary></QueryClientProvider>;
    $[4] = dehydratedState;
    $[5] = t2;
    $[6] = t3;
  } else {
    t3 = $[6];
  }
  return t3;
}
function _temp2() {
  return createTRPCClient({
    links: [httpBatchLink({
      url: apiUrl,
      fetch(url, options) {
        return fetch(url, {
          ...options,
          credentials: "include",
          body: options?.body as string
        }).then(_temp);
      },
      transformer: superjson
    })]
  });
}
function _temp(res) {
  if (!res.ok) {}
  return res;
}